/**
 * Este arquivo serve para limpar qualquer conexão SSE existente
 * e garantir que o polling funcione corretamente.
 */

/**
 * Função para desativar qualquer conexão SSE existente
 */
export const desativarSSE = (): void => {
  try {
    // Remover qualquer EventSource que possa estar armazenado em variáveis globais
    if ((window as any).eventSource) {
      (window as any).eventSource.close();
      (window as any).eventSource = null;
      console.log('Conexão SSE global desativada');
    }

    // Buscar e fechar qualquer EventSource que possa estar armazenado em localStorage
    const sseKeys = Object.keys(localStorage).filter(key => key.includes('sse') || key.includes('event'));
    if (sseKeys.length > 0) {
      sseKeys.forEach(key => localStorage.removeItem(key));
      console.log('Chaves SSE removidas do localStorage:', sseKeys);
    }

    console.log('Limpeza de conexões SSE concluída');
  } catch (error) {
    console.error('Erro ao desativar conexões SSE:', error);
  }
};

export default { desativarSSE };
